module.exports = __webpack_public_path__ + "static/media/dan-danMeinNoodles.672ed1ad.png";